// @flow
import './style.css';

import ImageGallery from 'react-image-gallery';

export default ImageGallery;
